export const Footer = () => {
  return (
    <footer className="footer footer-center select-none p-4 text-foreground">
      <aside>
        <p>© {new Date().getFullYear()} uPacjenta</p>
      </aside>
    </footer>
  );
};
